import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, args: string): string {
    if (!args) {
      return value;
    }

    const regex = new RegExp(args, 'gi');
    const match = value.match(regex);

    if (!match) {
      return value;
    }

    return value.replace(regex, `<mark>${match[0]}</mark>`);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/pipes/highlight.pipe.ts